import { render, staticRenderFns } from "./px-panel-section.vue?vue&type=template&id=21d301c2&scoped=true&"
import script from "./px-panel-section.vue?vue&type=script&lang=ts&"
export * from "./px-panel-section.vue?vue&type=script&lang=ts&"
import style0 from "./px-panel-section.vue?vue&type=style&index=0&id=21d301c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d301c2",
  null
  
)

export default component.exports